module.exports = function (app, mod) {
  return "\n    <div class=\"sidebar-stack\" hidden>\n      <div class=\"invites arcade-invites\"></div>\n    </div>\n    <div class=\"arcade-leaderboard redsquare-leaderboard\"></div>\n  ";
};